export default __webpack_public_path__ + "static/media/signup_three.4bb81bb5.png";